<template>
  <div>
    <div class="embed-responsive embed-responsive-16by9">
      <div class="player embed-responsive-item" ref="vidBoxV2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "radioPlayerComponent",
  props: ["id", "type"],
  mounted() {
    // Initialize once the element exists
    this.initialize();
  },
  methods: {
    initialize() {
      const target = this.$refs.vidBoxV2;
      if (!target || !this.id) return;
      this.initializePlayer(this.id, target, this.type);
    },
  },
  watch: {
    id: function(newVal) {
      const target = this.$refs.vidBoxV2;
      if (!target || !newVal) return;
      this.initializePlayer(newVal, target, this.type);
    },
  },
};
</script>

<style></style>
